import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CertifiedTable from '../components/CertifiedTable';
import API_BASE_URL from '../config';

function SearchOrganization() {

  useEffect(() => {
    document.title = "Search Organization | Outstanding Workplaces";
  }, []);

  const [company, setCompany] = useState('');
  const [orgs, setOrgs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [notFound, setNotFound] = useState(false);
  const [searched, setSearched] = useState(false);
  const navigate = useNavigate();

  const fetchOrgs = async (searchName, searchPage = 1, searchLimit = 25) => {
    const res = await fetch(`${API_BASE_URL}/api/companies/search?name=${encodeURIComponent(searchName)}&page=${searchPage}&limit=${searchLimit}`
    );
    const data = await res.json();
    if (res.ok && data && data.results && data.results.length > 0) {
      setOrgs(data.results);
      setTotal(data.total || data.results.length);
      setNotFound(false);
    } else {
      setOrgs([]);
      setTotal(0);
      setNotFound(true);
    }
    setSearched(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setPage(1);
    setOrgs([]);
    setTotal(0);
    setNotFound(false);
    setSearched(false);
    await fetchOrgs(company, 1, limit);
  };

  const handleNominate = () => {
    navigate('/nominate', { state: { companyName: company } });
  };

  // Pagination handler (if needed)
  const handlePageChange = async (newPage) => {
    setPage(newPage);
    await fetchOrgs(company, newPage, limit);
  };

  return (
    <div className="search-org-page">
      <h1 style={{ textAlign: 'center', margin: '40px 0 10px', fontSize: '25px', fontWeight: 700 }}>
        Search Your Workplace
      </h1>
      <form className="search-org-form" onSubmit={handleSearch} style={{ textAlign: 'center', marginBottom: 30 }}>
        <input
          type="text"
          placeholder="Enter Your Company Name"
          value={company}
          onChange={e => setCompany(e.target.value)}
          style={{
            width: 400, maxWidth: '90%', padding: '12px 7px', fontSize: '1.2rem',
            border: '2px solid #222', borderRadius: 6, marginBottom: 16
          }}
          required
        />
        <br />
        <button
          type="submit"
          style={{
            padding: '10px 32px',
            fontSize: '1.1rem',
            fontWeight: 600,
            border: 'none',
            borderRadius: 6,
            background: '#0b1d51',
            color: '#fff',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseOver={e => (e.currentTarget.style.background = '#f28500')}
          onMouseOut={e => (e.currentTarget.style.background = '#0b1d51')}
        >
          Search
        </button>
       <h2 style={{ fontSize: "23px" }}>
 Is your organization Outstanding Workplaces certified? Find out here.
</h2>
      </form>

      {orgs.length > 0 && searched && (
        <>
          <section className="micro-section-title">
            <div className="micro-section-title-container">
              <h2 className="micro-section-title-text">
                Certified Companies List
              </h2>
            </div>
          </section>
          <CertifiedTable
            orgs={orgs}
            total={total}
            page={page}
            limit={limit}
            setPage={handlePageChange}
            setLimit={setLimit}
          />
        </>
      )}

      {notFound && searched && (
        <div style={{ textAlign: 'center', margin: '40px 0' }}>
          <h2 style={{ fontWeight: 700, fontSize: '2rem', marginBottom: 10 }}>
            {company} is not present in our recognition list - not Certified as an Outstanding Workplaces.
          </h2>
          <p style={{ fontSize: '1.2rem', marginBottom: 24 }}>
            Please fill the nomination form, if you wish to nominate your organization.
          </p>
          <button
            style={{
              padding: '12px 32px',
              fontSize: '1.1rem',
              fontWeight: 600,
              border: 'none',
              borderRadius: 6,
              background: '#0b1d51',
              color: '#fff',
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            onMouseOver={e => (e.currentTarget.style.background = '#f28500')}
            onMouseOut={e => (e.currentTarget.style.background = '#0b1d51')}
            onClick={handleNominate}
          >
            Nominate Now
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchOrganization;